import customAxios from "../../customAxios";

import { TOTAL_FACTOR_PRICE_FOR_PARENT } from "../../routes";

type IData = {
  parentId: string;
  factorList: string[];
};

const totalFactorPriceForParent = async (formData: IData) => {
  try {
    return (
      await customAxios.post(
        TOTAL_FACTOR_PRICE_FOR_PARENT + "/" + formData.parentId,
        {
          factorList: formData.factorList,
        }
      )
    ).data;
  } catch (error: unknown) {
    console.error({ TOTAL_FACTOR_PRICE_FOR_PARENT: error });
    return false;
  }
};

export default totalFactorPriceForParent;
